import React from "react";
import Convert from "../../common/Convert";
import InputBase from "./InputBase";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import {
    Label
} from "reactstrap";

export default class InputSelectClearUndefined extends InputBase {
    static defaultProps = {
        label:'',
        labelOn:false,
        name:'',
        className:'',
        style:{},
        options:[],
        rootData:{
            values:{},
            errors:{},
            requiredData:{}
        },
        isSearchable:false,
        enterSearchFlag: false,
    }

    constructor(props) {
        super(props);
        this.handle_change = this.handle_change.bind(this)
        this.scroll_correction = this.scroll_correction.bind(this)
    }

    handle_change(value) {
        const trimmedValue = this.trim(value)

        this.validate(trimmedValue)
    }

    enterSearch(e){
        const ENTER = 13;
        if(this.props.enterSearchFlag == false){
            return
        }
        if (e.keyCode == ENTER) {
            if(this.selfDom.current.state.menuIsOpen){
                return;
            }
            this.props.enterCallback&&this.props.enterCallback();
        }
    }

    // 調査詳細の場合、調査状況を開いた際の自動スクロールを補正する
    scroll_correction(){
        if(this.props.isSurvey){
            const el = document.getElementsByClassName("map-nav")[0]
            const elTarget = document.getElementById("survey-status")
            setTimeout(() => {
                el.scrollTo(0, elTarget.offsetTop)
                window.scrollTo(0, elTarget.offsetTop - 200)
            }, 50);
        }
    }

    render() {
        const{
            disabled,
            name,
            label,
            labelOn,
            rootData:{
                // requiredData,
                errors,
                values
            },
            options,
            className,
            // style,
            isSearchable,
            isCreatable,
            isClearable=true,
            searchStartLength = 0
        } = this.props
        
        const columnObject = Convert.key_split(name)
        const value = values&&values[columnObject.column]
        const validate_message = errors&&errors[columnObject.column]
        const findValue = options.find((option)=>option.value==value);

        const filterOptions = (candidate, input) => {
            if (searchStartLength !== 0 && input.length < searchStartLength) {
                return false
            } else {
                return candidate.label.toLowerCase().includes(input.toLowerCase())
            }
        };
        return (
            
            <>
                {
                    labelOn &&
                    <Label for={name} className="search-text-order">
                        {label}
                        ：
                    </Label>
                }
                {
                    isCreatable
                    ?<CreatableSelect
                    ref={this.selfDom}
                    key={name}
                    formatCreateLabel={(value)=>`"${value}"を入力`}
                    isDisabled={disabled} 
                    className={`searchable-select ${className} tabable`} 
                    isSearchable={isSearchable} 
                    onChange={(option)=>this.handle_change(option&&option.value)} 
                    placeholder={`${label}を選択してください`} 
                    value={findValue || value && {label : value}}
                    options={options}
                    createOptionPosition="first"
                    isClearable={isClearable}
                    styles={{
                        input: styles => ({ 
                            ...styles
                            , maxWidth: 0
                         }),
                         menu: provided => ({ ...provided, zIndex: 9999 })
                    }}
                    onKeyDown={(e) => this.enterSearch(e)} 
                    filterOption={filterOptions}
                    />
                    : (findValue !== undefined ? <Select
                    ref={this.selfDom}
                    key={name}
                    isDisabled={disabled} 
                    className={`searchable-select ${className} tabable`} 
                    isSearchable={isSearchable} 
                    onChange={(option)=>this.handle_change(option&&option.value)} 
                    placeholder={`${label}を選択してください`} 
                    value={findValue} 
                    options={options}
                    isClearable={isClearable}
                    styles={{
                        menu: provided => ({ ...provided, zIndex: 9999 })
                    }}
                    {...(this.props.inTable ? {
                        menuPortalTarget : document.body, menuPosition : 'fixed'
                    }:{
                        onMenuOpen: () => {this.scroll_correction()}
                    })}
                    filterOption={filterOptions}
                    /> : <>
                    <Select
                    ref={this.selfDom}
                    key={name}
                    isDisabled={disabled} 
                    className={`searchable-select ${className} tabable`} 
                    isSearchable={isSearchable} 
                    onChange={(option)=>this.handle_change(option&&option.value)} 
                    placeholder={`${label}を選択してください`} 
                    options={options}
                    isClearable={isClearable}
                    styles={{
                        menu: provided => ({ ...provided, zIndex: 9999 })
                    }}
                    {...(this.props.inTable ? {
                        menuPortalTarget : document.body,
                        menuPosition : 'fixed',
                    }:{
                        onMenuOpen: () => {this.scroll_correction()}
                    })}
                    filterOption={filterOptions}
                    /></>)
                }
                {
                    validate_message instanceof Array && validate_message.length>0 &&
                    <p id={name} style={{ color: "red" }}>{validate_message.length>0?validate_message[0]:validate_message}</p>
                }
            </>
        );
    }
}
